import type { DesignDocument, DesignDocumentWithPanels } from '@mcp-artwork/cimdoc';

export function isDesignDocumentWithPanels(document: DesignDocument): document is DesignDocumentWithPanels {
    return !!(document as DesignDocumentWithPanels).panels;
}
